import React, {useState} from "react";
import Calendar from "react-calendar";
import Button from "../../../UI/Button";
import Popup from "../../Popup";

import "react-calendar/dist/Calendar.css";
import useGetTechnicianCalendar from "../../../Global/Api/Schedule/getTechnicianCalendarApi";

export default function TechItemModal({closeModal, item}) {
  const {get, list, setList} = useGetTechnicianCalendar();
  const [date, setDate] = useState(null);

  return (
    <Popup title="Availability" closePopup={closeModal}>
      <div className="tech__modal">
        <div className="tech__modal-user">
          <div className="left">
            <div className="tech__modal-image">
              <img
                src={
                  item?.profile_image_url ? item?.profile_image_url : item?.item?.profile_image ? item?.item?.profile_image : `/assets/images/avatar-placeholder.png`
                }
                alt="user"
              />
            </div>
            <div className="tech__modal-info">
              <div className='tech__modal-inner'>
                {item?.firstname ? (
                  <span className="tech__item-name">
                  {item?.firstname} {item?.lastname}
                </span>
                ) : (
                  <span className="tech__item-name">
                {item?.name}
                  </span>
                  )}
                {item?.average_rating && (
                  <span className="tech__item-rate">
                    <img src="/assets/icons/big-star-active.svg" alt="rate"/>
                    <span>{item?.average_rating}</span>
                  </span>
                )}
              </div>
              <div className="tech__item-id">Tech ID: {item?.id}</div>
            </div>
          </div>
          <div className="right">
            <div className="tech__item-distance">
              <div className="tech__item-miles">{item?.distance_text}</div>
              <span>{item?.distance_text ? "Round Trip Distance" : ""}</span>
            </div>
          </div>
        </div>

        <div className="tech__modal-body">
          <div className="tech__modal-calendar">
            <Calendar
              selectRange={true}
              calendarType="US"
              onChange={(date) => {
                get(date, item);
                setDate(date);
              }}
              value={date}
            />
            <div className="tech__modal-calendar-btn">
              <Button
                type="transparent"
                text="Clear selection"
                onClick={() => {
                  setList(null);
                  setDate(null);
                }}
              />
            </div>
          </div>
          <div className="tech__modal-events">
            {list?.length > 0 ? (
              list?.map((elem, index) => (
                <div key={index} className="tech__modal-event">
                  <div className="event__header">
                    <span>{elem?.date}</span>
                    <span>
                      Working hours:{" "}
                      {elem?.working_hours
                        ? elem?.working_hours
                        : elem?.events[0].type}
                    </span>
                  </div>
                  {elem?.events?.length > 0 &&
                  elem?.events?.map((d, idx) => (
                    <div
                      key={d?.id}
                      className={`event__item ${
                        d?.type === "Job" ? "job" : "event"
                      }`}
                    >
                      <div className="event__item-icon">
                        <img
                          src={
                            d?.type === "Job"
                              ? "/assets/icons/event-job.svg"
                              : "/assets/icons/event-calendar.svg"
                          }
                          alt="event"
                        />
                      </div>
                      <div className="event__item-info">
                        <span>{d?.type}</span>
                        <span>{d?.time}</span>
                      </div>
                    </div>
                  ))}
                </div>
              ))
            ) : (
              <span>Pick start and end date</span>
            )}
          </div>
        </div>
        <div className="tech__modal-footer">
          <Button text="Close" onClick={closeModal}/>
        </div>
      </div>
    </Popup>
  );
}
